<!-- <app-popup></app-popup> -->
<app-navbar [makeTransparent]="transparentNavbar"></app-navbar>
<router-outlet></router-outlet>
<app-ambassador></app-ambassador>
<app-footer></app-footer>
